// For phison
// CKS-4765 => 第一個為英文即可（不看大小寫），後面為數字，不限制長度。
// employeeId : 員工編號
const employeeValidator = (employeeId: string) => {
  if (!employeeId) {
    return false;
  }

  const checkEmployeeId = /^[a-zA-Z][0-9]+$/;
  if (!checkEmployeeId.test(employeeId)) {
    return false;
  }

  return true;
};

export default employeeValidator;
